import React, {useState, useEffect} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {motion, AnimatePresence} from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import IntroAnimation from './components/IntroAnimation';
import {ThemeProvider} from './context/ThemeContext';
import {LanguageProvider} from './context/LanguageContext';
import './App.css';

function App() {
  const [showIntro, setShowIntro] = useState(true);

  useEffect(() => {
    const hasSeenIntro = sessionStorage.getItem('hasSeenIntro');
    if (hasSeenIntro) {
      setShowIntro(false);
    } else {
      const timer = setTimeout(() => {
        setShowIntro(false);
        sessionStorage.setItem('hasSeenIntro', 'true');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleIntroComplete = () => {
    setShowIntro(false);
    sessionStorage.setItem('hasSeenIntro', 'true');
  };

  return (
    <LanguageProvider>
      <ThemeProvider>
        <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
          <AnimatePresence mode="wait">
            {showIntro ? (
              <IntroAnimation key="intro" onComplete={handleIntroComplete} />
            ) : (
              <motion.div
                key="main"
                initial={{opacity: 0}}
                animate={{opacity: 1}}
                transition={{duration: 0.5}}
                className="min-h-screen flex flex-col"
              >
                <Router>
                  <Header />
                  <main className="flex-1">
                    <Routes>
                      <Route path="/" element={<Home />} />
                    </Routes>
                  </main>
                  <Footer />
                </Router>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;